import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/react';

export interface SkeletonStyles {
  styles?: SerializedStyles;
}
export const SkeletonStyle = css`
  @keyframes skeleton-gradient {
    0% {
      opacity: 0.1;
    }

    50% {
      opacity: 0.3;
    }

    100% {
      opacity: 0.1;
    }
  }
  -webkit-animation: skeleton-gradient 1.8s infinite ease-in-out;
  animation: skeleton-gradient 1.8s infinite ease-in-out;
`;

export const SkeletonDiv = styled.div`
  width: 500px;
  height: 40px;
  background-color: #a5a5a5;
  ${SkeletonStyle};
  ${(props: SkeletonStyles) => props.styles};
`;
